import { Component } from '@angular/core';
import {animate, state, style, transition, trigger} from '@angular/animations';
import { NavigationEnd, Router } from '@angular/router';
import { PerfilamientoService } from 'src/app/services/perfilamiento/perfilamiento.service';
import { IConfiguracionUsuario } from 'src/app/interfaces/usuarios';
import { UsuariosService } from 'src/app/services/usuarios/usuarios.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-view-header',
  templateUrl: './view-header.component.html',
  styleUrls: ['./view-header.component.scss'],
  animations: [
    trigger('slideInOut', [
      state('in', style({
        transform: 'translate3d(0,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(-100%, 0, 0)'
      })),
      transition('in => out', animate('400ms ease-in-out')),
      transition('out => in', animate('400ms ease-in-out'))
    ]),
    trigger('slideInOut2', [
      state('in', style({
        transform: 'translate3d(0,0,0)'
      })),
      state('out', style({
        transform: 'translate3d(100%, 0, 0)'
      })),
      transition('in => out', animate('500ms ease-in-out')),
      transition('out => in', animate('500ms ease-in-out'))
    ])
  ]
})
export class ViewHeaderComponent {
  sidebar: string = "out";
  lista: any[] = [];
  displaySidebar: string = "none";
  pagina: number = 1;
  showMenu: boolean = false
  showLogoutBtn: boolean = false
  menuItems: any = []
  user: IConfiguracionUsuario | null = null
  redirectLogoUrl: string = '/view-inicio'

  constructor(
    private router: Router,
    private _perfilamiento: PerfilamientoService,
    private _usuarios: UsuariosService
  ) {
    this.router.events.subscribe((event) => {
      if ( event instanceof NavigationEnd ) {
        if ( event.url === '/view-inicio' && this.user ) {
          this.showMenu = true
        }
      }
    })

    // Menu dinamico
    this._perfilamiento.getSyncMenu.subscribe(
      (res: any) => {
        this.menuDinamico(res)
      }
    )
    this.menuDinamico(this._perfilamiento.getMenu())

    this._perfilamiento.getSyncUser.subscribe(
      (res: any) => {
        if ( res !== 'logged out' ) {
          this.syncUsuario(res)
        } else {
          this.user = null
        }
      }
    )
    this.syncUsuario(this._perfilamiento.getUsuario())
  }

  syncUsuario(user: any) {
    this.user = user
    if ( !this.user ) {
      // this.router.navigate(['/login'])
    }

    if (user.tipoUsuario == 'Docente') {
      this.redirectLogoUrl = '/portal-calificacion'
    } else {
      this.redirectLogoUrl = '/view-inicio'
    }
  }

  menuDinamico(menuItems: any) {
    if ( menuItems.modulos ) {
      menuItems.modulos.forEach((item: any) => {
        item.showItem = false
      })
      this.menuItems = menuItems.modulos
    }
  }

  ngOnInit() {
    let dis = this
    window.addEventListener('click', function(e: any){
      if ( !document?.getElementById('cstm-side-menu')?.contains(e.target)  && !document?.getElementById('cstm-side-menu-btn')?.contains(e.target) ){
        dis.showMenu = false
      }
    })
  }

  mostrarSidebar(): void {
    this.showMenu = !this.showMenu
  }

  toggleLogoutBtn() {
    this.showLogoutBtn = !this.showLogoutBtn
  }

  logout() {
    this._perfilamiento.deleteUsuario()
    this._perfilamiento.asyncUserData(null)
    this._perfilamiento.deleteMenu()
    this._perfilamiento.asyncMenuData(null)
    this._usuarios.removeToken()
    if ( environment.devLocal ) {
      this.router.navigate(['/login'])
    } else {
      window.location.href = environment.logoutUrl
    }
  }

}
